function formatWhatsAppNumber(number) {
  if (!number) return "";

  // remove spaces, dashes, brackets
  number = number.toString().replace(/[^\d+]/g, "");

  // remove +
  if (number.startsWith("+")) {
    number = number.slice(1);
  }

  // Pakistan local format: 03XXXXXXXXX
  if (/^03\d{9}$/.test(number)) {
    return "92" + number.slice(1);
  }

  // Pakistan format already with 92
  if (/^92\d{10}$/.test(number)) {
    return number;
  }

  // If other country code (10–15 digits typical international length)
  if (/^\d{10,15}$/.test(number)) {
    return number;
  }

  return number;
}
export default formatWhatsAppNumber;
